import { Injectable } from "@angular/core";
import { Coords } from '../../models/coords';
import { HttpClient } from "@angular/common/http";
import { MotesPaths } from "@motes-sdk/models";

export interface JourneyRsp {
    TripList: {
        Trip: any[]
    }
}

export interface JourneyDetails {
    JourneyDetail: any;
}

@Injectable({ providedIn: 'root' })
export class TransportationService {
    readonly MOTES_PROXY = MotesPaths.MOTES_REST + '/api/proxy';
    //readonly MOTES_PROXY = "http://localhost:5000/api/proxy";

    constructor(private http: HttpClient) {
    }

    lookupJourney(startName: string, start: Coords, endName: string, end: Coords, date: Date): Promise<JourneyRsp> {
        const BASE_URL = this.MOTES_PROXY + "?motekey=myMoteKy&url=http://xmlopen.rejseplanen.dk/bin/rest.exe";

        let startPlace = `originCoordName=${startName}%26originCoordY=${start.lat * 1000000}%26originCoordX=${start.long * 1000000}`;
        let endPlace = `destCoordName=${endName}%26destCoordY=${end.lat * 1000000}%26destCoordX=${end.long * 1000000}`;

        let dateUrl = `date=${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
        let timeUrl = `time=${date.getHours()}:${date.getMinutes()}`;
        let transUrl = `useBus=1%26useTrain=1%26useMetro=1`;

        // Consider using useBicycle=1 to enforce trips only with bike
        let url = BASE_URL + `/trip?${startPlace}%26${endPlace}%26${dateUrl}%26${timeUrl}%26${transUrl}%26format=json`;

        return this.http.get<JourneyRsp>(url).toPromise();
    }

    lookupJourneyDetails(jorneyRefUrl: string): Promise<JourneyDetails> {
        const url = this.MOTES_PROXY + "?motekey=myMoteKy&url=" + jorneyRefUrl;
        return this.http.get<JourneyDetails>(url).toPromise();
    }

    lookupRouteIdx() {
        // routeIdx
    }
}
